import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeStep: 1, // Tracks the current step
  formData: {} // Stores data for each step
};

const stepperSlice = createSlice({
  name: "stepper",
  initialState,
  reducers: {
    nextStep: (state) => {
      state.activeStep += 1;
    },
    prevStep: (state) => {
      if (state.activeStep > 0) {
        state.activeStep -= 1;
      }
    },
    goToStep: (state, action) => {
      state.activeStep = action.payload; // Directly navigate to a specific step
    },
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    resetStepper: () => initialState // Reset the stepper to initial state
  }
});

export const { nextStep, prevStep, goToStep, updateFormData, resetStepper } =
  stepperSlice.actions;

export default stepperSlice.reducer;
